const footerData = {
  de: {
    homeRedirection: "/de-de/",
    topSection: [
      {
        heading: "Lösungen",
        href: "",
        data: [
          {
            label: "Lösungen für Konzern & Mittelstand",
            href: "https://www.dnb.com/de-de/loesungen.html",
            target: "_self"
          },
          {
            label: "Lösungen für Kleinunternehmen",
            href: "https://www.dnb.com/de-de/kleinunternehmen.html",
            target: "_self"
          },
          {
            label: "D-U-N-S Nummer",
            href: "/de-de/upik.html",
            target: "_self",
          },
          {
            label: "Blog",
            href: "https://www.dnb.com/de-de/blog.html",
            target: "_self",
          },
          {
            label: "Ressourcen",
            href: "https://www.dnb.com/de-de/ressourcen.html",
            target: "_self"
          }
        ],
      },
      {
        heading: "Unternehmen",
        href: "",
        data: [
          {
            label: "Unser Unternehmen",
            href: "https://www.dnb.com/de-de/ueber-uns.html",
            target: "_self"
          },
          {
            label: "Worldwide Network",
            href: "https://www.dnb.com/en-us/why-dnb/partnerships/worldwide-network.html",
            target: "_self"
          },
          {
            label: "Karriere",
            href: "https://www.dnb.com/de-de/ueber-uns/karriere.html",
            target: "_self"
          },
          {
            label: "Unser Management",
            href: "https://www.dnb.com/de-de/ueber-uns/management.html",
            target: "_self"
          },
          {
            label: "Investor Relations",
            href: "https://investor.dnb.com/home/default.aspx",
            target: "_blank"
          },
          {
            label: "ESG- und Diversitätsverpflichtungen",
            href: "https://www.dnb.com/de-de/ueber-uns/ESG.html",
            target: "_self"
          },
        ],
      },
      {
        heading: "Unterstützung",
        href: "",
        data: [
          {
            label: "Kundendienst",
            href: "https://service.dnb.com/de-de/",
            target: "_blank"
          }
        ],
      },
    ],
    bottomSection: [
      [{
        label: "Ihre Daten-und Datenschutzoptionen",
        redirection: "https://submit-irm.trustarc.eu/services/validation/ba81b98f-997d-4216-b4cc-d64cf261b082",
        target: "_blank",
      },
      {
        label: "Datenschutz",
        redirection: "https://www.dnb.com/de-de/warum-dnb/datenschutz.html",
        target: "_self",
      },
      {
        label: "Impressum",
        redirection: "https://www.dnb.com/de-de/impressum.html",
        target: "_self",
      }],
      [{
        label: "Allgemeine Geschäftsbedingungen",
        redirection: "https://www.dnb.com/de-de/agb.html",
        target: "_self",
      },
      {
        label: "Cookie-Einstellungen",
        redirection: "https://www.dnb.com/content/dam/web/company/about/content/cps/DnB_Cookie-Policy-Statement.pdf",
        target: "_self",
      },
      {
        label: "Transparenzerklärung",
        redirection: "https://www.dnb.com/de-de/transparency-statement.html",
        target: "_self"
      }
     ],
    ],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon facebook ext-icon"
      },
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "http://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon linkedin ext-icon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://twitter.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon twitter ext-icon"
      },
    ],
    globeRedirection: "https://www.dnb.com/de-de/change-market.html",
    footerDescription: "Dun & Bradstreet unterstützt große und kleine Unternehmen dabei, ihr Wachstum voranzutreiben, Risiken zu managen und die Leistung ihres Unternehmens zu steigern.",
    contactUsLabel: "Kontaktieren Sie uns",
    contactUs: "https://service.dnb.com/de-de/private",
    companyRightsLabel:  "© Dun & Bradstreet, Inc. 2000 - 2025. Alle Rechte vorbehalten.",
  },
  at: {
    homeRedirection: "/de-at/",
    topSection: [
      {
        heading: "Jetzt kontaktieren",
        href: "",
        data: [
          {
            label: "0800 400 5335",
            href: "tel:0800 400 5335",
            target: "_blank"
          },
          {
            label: "CustomerService.at@dnb.com",
            href: "mailto:CustomerService.at@dnb.com",
            target: "_self"
          },
          {
            label:
              "Dun & Bradstreet Austria GmbH ~~Office: +43 (0)1 58861-0 ~~E-Mail: office.at@dnb.com ~~Sitz der Gesellschaft: Jakov-Lind Straße 4/1, 1020 Wien ~~Geschäftsführer: Isabella Blüml",
            href: "",
            disable: true,
          },
        ],
      },
      {
        heading: "Über Dun & Bradstreet",
        href: "",
        data: [
          {
            label: "Über uns",
            href: "https://www.dnb.com/de-at/ueber-uns.html",
            target: "_self"
          },
          {
            label: "Was wir tun ",
            href: "https://www.dnb.com/de-at/ueber-uns/was-wir-tun.html",
            target: "_self"
          },
          {
            label: "Unsere Kunden ",
            href: "https://www.dnb.com/de-at/ueber-uns/kunden.html",
            target: "_self"
          },
          {
            label: "Karrieren",
            href: "https://www.dnb.com/content/dnb-us/en/home/about-us/careers-and-people/joblistings",
            target: "_self"
          },
          {
            label: "D&B D-U-N-S®-Nummer",
            href: "https://www.dnb.com/de-at/produkte-services/dun-bradstreet/dnb-duns-nummer.html",
            target: "_self"
          },
          {
            label: "Entwickler",
            href: "https://www.dnb.com/en-gb/developers.html",
            target: "_self"
          },
        ],
      },
      {
        heading: "Themen",
        href: "",
        data: [
          {
            label: "Scoring",
            href: "https://www.dnb.com/de-at/themen/scoring-von-unternehmen-weltweit.html",
            target: "_blank"
          },
          {
            label: "Data driven Leadmanagement",
            href: "https://www.dnb.com/de-at/themen/data-driven-leadmanagement.html",
            target: "_blank"
          },
        ],
      },
      {
        heading: "Kontakt & Hilfe",
        href: "",
        data: [
          {
            label: "Kontaktieren Sie uns",
            href: "https://www.dnb.com/de-at/kontakt.html",
            target: "_blank"
          },
          {
            label: "FAQ",
            href: "https://www.dnb.com/de-at/kontakt/kundenservice/faq.html",
            target: "_blank"
          },
          {
            label: "Newsletter",
            href: "https://www.dnb.com/de-at/lp/newsletter-anmeldung.html",
            target: "_blank"
          },
        ],
      },
    ],
    bottomSection: [[
      {
        label: "Impressum",
        redirection: "https://www.dnb.com/de-at/impressum.html",
        target: "_self",
      },
      {
        label: "AGB",
        redirection: "https://www.dnb.com/de-at/agb.html",
        target: "_blank",
      },
      {
        label: "Cookies",
        redirection: "https://www.dnb.com/de-at/cookies.html",
        target: "_blank",
      },
      {
        label: "Transparenzerklärung",
        redirection: "https://www.dnb.com/de-at/transparency-statement.html",
        target: "_self",
      },
      {
        label: "Cookie-Einstellungen",
        target: "_self",
        cookieRedirection: true
      },
    ]],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon"
      },
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "http://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://twitter.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon"
      },
    ],
    globeRedirection: "https://www.dnb.com/de-at/change-market.html",
    contactUs: "",
    contactUsLabel: "",
    companyRightsLabel: ""
  },
  ch: {
    homeRedirection: "/de-ch/",
    topSection: [
      {
        heading: "Jetzt kontaktieren",
        href: "",
        data: [
          {
            label: "Dun & Bradstreet~~Schweiz AG",
            href: "https://www.google.ch/maps/place/Dun+%26+Bradstreet+Schweiz+AG/@47.3918873,8.4143066,17z/data=!3m1!4b1!4m6!3m5!1s0x47900c39a3acf7bd:0x77f4e3083fc6c7ed!8m2!3d47.3918837!4d8.4168815!16s%2Fg%2F1tfphqrd?entry=ttu",
            target: "_blank"
          },
          {
            label: "+ 41 (0)44 735 61 11",
            href: "tel:+41 (0)44 735 61 11",
            target: "_blank"
          },
          {
            label: "CustomerService.ch@dnb.com",
            href: "mailto:CustomerService.ch@dnb.com",
            target: "_self"
          },
          {
            label:
              "Grossmattstrasse 9, 8902 ~~Urdorf, Schweiz ~~UID-Nummer: ~~CHE-105.835.538",
            href: "",
            disable: true,
          },
        ],
      },
      {
        heading: "Über Dun & Bradstreet",
        href: "",
        data: [
          {
            label: "Über uns",
            href: "https://www.dnb.com/de-ch/ueber-uns.html",
            target: "_self"
          },
          {
            label: "Was wir tun ",
            href: "https://www.dnb.com/de-ch/ueber-uns/was-wir-tun.html",
            target: "_self"
          },
          {
            label: "Unsere Kunden ",
            href: "https://www.dnb.com/de-ch/ueber-uns/kunden.html",
            target: "_self"
          },
          {
            label: "Karriere",
            href: "https://jobs.lever.co/dnb",
            target: "_self"
          },
          {
            label: "D&B D-U-N-S®-Nummer",
            href: "https://www.dnb.com/de-ch/produkte-services/dun-bradstreet/dnb-duns-nummer.html",
            target: "_self"
          },
          {
            label: "Entwickler",
            href: "https://www.dnb.com/en-gb/developers.html",
            target: "_self"
          },
        ],
      },
      {
        heading: "Kontakt & Hilfe",
        href: "",
        data: [
          {
            label: "Kontaktieren Sie uns",
            href: "https://www.dnb.com/de-ch/kontakt.html",
            target: "_blank"
          },
          {
            label: "Sofortauskunft bestellen",
            href: "https://www.dnb.com/de-ch/sofortauskunft-bestellen.html",
            target: "_blank"
          },
          {
            label: "FAQ",
            href: "https://www.dnb.com/de-ch/kontakt/kundenservice/faq.html",
            target: "_blank"
          },
          {
            label: "Newsletter",
            href: "https://www.dnb.com/de-ch/lp/newsletter-anmeldung.html",
            target: "_blank"
          },
        ],
      },
      {
        heading: "Themen",
        href: "",
        data: [
          {
            label: "Risikomanagement",
            href: "https://www.dnb.com/de-ch/themen/kluge-entscheidungen.html",
            target: "_blank"
          },
          {
            label: "Data driven Leadmanagement",
            href: "https://www.dnb.com/de-ch/themen/data-driven-leadmanagement.html",
            target: "_blank"
          },
        ],
      },
    ],
    bottomSection: [
    [
      {
        label: "Impressum",
        redirection: "https://www.dnb.com/de-ch/impressum.html",
        target: "_self",
      },
      {
        label: "AGB",
        redirection: "https://www.dnb.com/de-ch/agb.html",
        target: "_blank",
      },
      {
        label: "Cookies",
        redirection: "https://www.dnb.com/de-ch/cookies.html",
        target: "_blank",
      },
      {
        label: "Transparenzerklärung",
        redirection: "https://www.dnb.com/de-ch/transparency-statement.html",
        target: "_self",
      },
      {
        label: "Cookie Präferenzen",
        redirection:
          "https://www.dnb.com/content/dnb-ch/de/startseite/transparency-statement/#anchor-Overview",
        target: "_self",
      },
    ]],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon"
      },
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "http://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://twitter.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon"
      },
    ],
    globeRedirection: "https://www.dnb.com/de-ch/change-market.html",
  },
  pl: {
    homeRedirection: "/pl-pl/",
    topSection: [
      {
        heading: "Skontaktuj się z nami",
        href: "",
        data: [
          {
            label: "Plac Europejski 2, 00-844 Warszawa",
            href: "https://www.dnb.com/pl-pl/kontakt-i-pomoc.html",
            target: "_blank"
          },
          {
            label: "kontakt.pl@dnb.com ~Tel: +48 22 278 26 26",
            href: "mailto:kontakt.pl@dnb.com",
            target: "_self"
          },
          {
            label: "NIP firmy: 7742855054 DUNS firmy: 522111111",
            // href: "mailto:CustomerService.de@dnb.com",
          },
        ],
      },

      {
        heading: "Tematy",
        href: "",
        data: [
          {
            label: "Dun & Bradstreet - o nas",
            href: "https://www.dnb.com/pl-pl/o-nas.html",
            target: "_self"
          },
          {
            label: "Compliance",
            href: "https://www.dnb.com/pl-pl/tematy/compliance.html",
            target: "_self"
          },
          {
            label: "Smart data",
            href: "https://www.dnb.com/pl-pl/tematy/smart-data.html",
            target: "_self"
          },
          {
            label: "Raport o firmie",
            href: "https://www.dnb.com/pl-pl/produkty/raport-handlowy.html",
            target: "_self"
          },
          {
            label: "Integracja API",
            href: "https://www.dnb.com/pl-pl/produkty/dun-bradstreet/db-direct-master-data.html",
            target: "_self"
          },
        ],
      },
      {
        heading: "Obsługa klienta",
        href: "",
        data: [
          {
            label: "Zapisz się do newslettera",
            href: "https://www.dnb.com/pl-pl/produkty/zapisz-sie-do-newslettera.html",
            target: "_self"
          },
          {
            label: "Kontakt i pomoc",
            href: "https://www.dnb.com/pl-pl/kontakt-i-pomoc.html",
            target: "_self"
          },
          {
            label: "Warunki i regulaminy",
            href: "https://www.dnb.com/pl-pl/produkty/warunki-i-regulaminy.html",
            target: "_self"
          },
        ],
      },
    ],
    bottomSection: [[
      {
        label: "Pliki cookie",
        redirection: "https://www.dnb.com/pl-pl/pliki-cookie.html",
        target: "_self",
      },
      {
        label: "Regulamin",
        redirection:
          "https://www.dnb.com/content/dam/bisnode/international/pdf_docs/Bisnode%20Polska_Regulamin_swiadczenia_uslug_droga_elektroniczna.pdf",
        target: "_blank",
      },
      {
        label: "Polityka prywatności",
        redirection:
          "https://www.dnb.com/content/dam/bisnode/international/pdf_docs/dun--bradstreet_polityka_prywatnosci_2022_09_05.pdf",
        target: "_blank",
      },
      {
        label: "Oświadczenie o przejrzystości",
        redirection: "https://www.dnb.com/pl-pl/transparency-statement.html",
        target: "_self",
      },
      {
        label: "Oświadczenie o przejrzystości",
        redirection: "https://www.dnb.com/pl-pl/transparency-statement.html",
        target: "_self",
      },
      {
        label: "Ustawienia cookies",
        target: "_self",
        cookieRedirection: true
      },
    ]],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon"
      },
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "http://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://twitter.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon"
      },
    ],
    globeRedirection: "https://www.dnb.com/pl-pl/change-market.html",
  },
  hu: {
    homeRedirection: "/hu-hu/",
    topSection: [
      {
        heading: "Vegye fel velünk a kapcsolatot",
        href: "",
        data: [
          {
            label: "1093 Budapest, Közraktár u. 30-32.",
            href: "https://www.google.hu/maps/place/Dun+%26+Bradstreet+Hungary+Kft./@47.4815267,19.065257,15z/data=!4m6!3m5!1s0x4741c2d994222ce7:0xa3b529dea757dc5e!8m2!3d47.4811565!4d19.065843!16s%2Fg%2F12hnz4xgv?entry=ttu",
            target: "_blank"
          },
          {
            label: "+36 1 815-8500",
            href: "tel:+3618158500",
            target: "_blank"
          },
          {
            label: "info.hungary@dnb.com",
            href: "mailto:info.hungary@dnb.com",
            target: "_self"
          },
          {
            label: "Dun & Bradstreet Hungary Kft.",
            href: "",
            disable: true,
          },
          {
            label: "Adószám: 10769931-2-43",
            href: "",
            disable: true,
          }
        ],
      },
      {
        heading: "Rólunk",
        href: "",
        data: [
          {
            label: "A Dun & Bradstreet-ről",
            href: "https://www.dnb.com/hu-hu/rolunk-uj.html",
            target: "_self"
          },
          {
            label: "Mivel foglalkozunk?",
            href: "https://www.dnb.com/hu-hu/rolunk-uj/mivel-foglalkozunk.html",
            target: "_self"
          },
        ],
      },
      {
        heading: "Elérhetőségünk",
        href: "",
        data: [
          {
            label: "Kapcsolat",
            href: "https://www.dnb.com/hu-hu/kapcsolat.html",
            target: "_blank"
          },
        ],
      },
    ],
    bottomSection: [[
      {
        label: "ÁSZF",
        redirection: "https://www.dnb.com/hu-hu/aszf.html",
        target: "_self",
      },
      {
        label: "Adatkezelés",
        redirection: "https://www.dnb.com/hu-hu/adatkezelesi-tajekoztato.html",
        target: "_self",
      },
      {
        label: "Adatkezelési tájékoztató",
        redirection: "https://www.dnb.com/hu-hu/adatkezelesi-tajekoztato.html",
        target: "_self",
      },
      {
        label: "Átláthatósági nyilatkozat",
        redirection: "https://www.dnb.com/hu-hu/transparency-statement.html",
        target: "_self",
      },
      {
        label: "Cookie beállítások",
        target: "_self",
        cookieRedirection: true
      },
    ]],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon"
      },
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "http://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://twitter.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon"
      },
    ],
    globeRedirection: "https://www.dnb.com/hu-hu/change-market.html",
  },
  us: {
    homeRedirection: "/en-us/",
    topSection: [
      {
        heading: "Solutions and Insights",
        href: "",
        data: [
          {
            label: "Enterprise Solutions",
            href: "https://www.dnb.com/en-us/solutions.html",
            target: "_self"
          },
          {
            label: "Small Business Solutions",
            href: "https://www.dnb.com/en-us/smb.html",
            target: "_self"
          },
          {
            label: "Public Sector Solutions",
            href: "https://www.dnb.com/en-us/public-sector.html",
            target: "_self"
          },
          {
            label: "D-U-N-S Number",
            href: "https://www.dnb.com/en-us/smb/duns.html",
            target: "_self"
          },
          {
            label: "Blog",
            href: "https://www.dnb.com/en-us/blog.html",
            target: "_self"
          },
          {
            label: "Resources",
            href: "https://www.dnb.com/en-us/resources.html",
            target: "_self"
          },
          {
            label: "Newsroom",
            href: "https://investor.dnb.com/news/default.aspx",
            target: "_self"
          },
          {
            label: "Community",
            href: "https://community.dnb.com/",
            target: "_self"
          },
        ],
      },// completed 1
      {
        heading: "Company",
        href: "",
        data: [
          {
            label: "Our Company",
            href: "https://www.dnb.com/en-us/about.html",
            target: "_self"
          },
          {
            label: "Partners",
            href: "https://www.dnb.com/en-us/why-dnb/partnerships.html",
            target: "_self"
          },
          {
            label: "Worldwide Network",
            href: "https://www.dnb.com/en-us/why-dnb/partnerships/worldwide-network.html",
            target: "_self"
          },
          {
            label: "Careers",
            href: "https://www.dnb.com/en-us/about/careers.html",
            target: "_self"
          },
          {
            label: "Leadership",
            href: "https://www.dnb.com/en-us/about/leadership.html",
            target: "_self"
          },
          {
            label: "Investor Relations",
            href: "https://investor.dnb.com/home/default.aspx",
            target: "_self"
          },
          {
            label: "ESG & DEI Commitments",
            href: "https://www.dnb.com/en-us/about/ESG.html",
            target: "_self"
          },
        ],
      },//completed 2
      {
        heading: "Support",
        href: "",
        data: [
          {
            label: "Customer Service",
            href: "https://service.dnb.com/",
            target: "_blank"
          },
          {
            label: "Update Company Information",
            href: "https://www.dnb.com/en-us/smb/duns/duns-manager.html",
            target: "_blank"
          },
          {
            label: "MyD&B Login",
            href: "https://my.dnb.com/login",
            target: "_blank"
          },
          {
            label: "Contact Us",
            href: "https://www.dnb.com/en-us/about/contact-us.html",
            target: "_self"
          },
          {
            label: "Communication Preferences",
            href: "https://www.dnb.com/utility-pages/communication-preferences.html",
            target: "_blank"
          },
        ],
      },
    ],
    bottomSection: [
      [{
        label: "Your Privacy Choices",
        redirection: "https://submit-irm.trustarc.eu/services/validation/ba81b98f-997d-4216-b4cc-d64cf261b082",
        target: "_blank",
      },
      {
        label: "Policies & Codes of Conduct",
        redirection: "https://www.dnb.com/en-us/utilities/policies-codes-of-conduct.html",
        target: "_self",
      },
      {
        label: "Trust Centre",
        redirection: "https://www.dnb.com/en-us/why-dnb/data-transparency.html",
        target: "_self",
      }],

      [{
        label: "Accessibility",
        redirection: "https://www.dnb.com/en-us/utilities/accessibility.html",
        target: "_self",
      },
      {
        label: "Terms of Use",
        redirection: "https://www.dnb.com/en-us/utilities/terms-of-use.html",
        target: "_self",
      },
      {
        label: "Cookie Preferences",
        redirection:"https://www.dnb.com/content/dam/web/company/about/content/cps/DnB_Cookie-Policy-Statement.pdf",
        target: "_self",
      },
      {
        label: "Data Source Attribution",
        redirection: "https://www.dnb.com/en-us/utilities/data-source-attribution-statements.html",
        target: "_self",
      },
     ],
    ],
    socialSiteSection: [
      {
        ariaLabel: "Follow us on linkedin. External Website. Opens New Window.",
        redirection: "https://www.linkedin.com/company/dun-&-bradstreet",
        target: "_blank",
        className: "linkedinIcon"
      },
      {
        ariaLabel: "Follow us on facebook. External Website. Opens New Window.",
        redirection: "https://www.facebook.com/DunBradstreet",
        target: "_blank",
        className: "facebookIcon"
      },
      {
        ariaLabel: "Follow us on twitter. External Website. Opens New Window.",
        redirection: "https://x.com/DunBradstreet",
        target: "_blank",
        className: "twitterIcon"
      },
    ],
    globeRedirection: "",
    footerDescription: "Dun & Bradstreet helps companies large and small drive growth, manage risk, and strengthen the performance of their business.",
    contactUs: "https://www.dnb.com/en-us/about/contact-us.html",
    contactUsLabel: "Contact Us",
    companyRightsLabel:  "© Dun & Bradstreet, Inc. 2000 - 2025. All rights reserved.",
  },
};

export default footerData;